import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/** Bloque l'accès aux routes protégées si l'utilisateur n'est pas authentifié. */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }
  return router.createUrlTree(['/auth/login']);
};

/**
 * Guard de permission — à utiliser via `data: { permission: 'id-mail.access' }`
 * pour refléter les droits du socle (spatie/laravel-permission côté back).
 */
export const permissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const required = route.data?.['permission'] as string | undefined;

  if (!required || auth.hasPermission(required)) {
    return true;
  }
  // Rediriger vers '/' créerait une boucle : '/' redirige vers 'id-mail',
  // lui-même protégé par ce guard. On cible une page terminale dédiée.
  return router.createUrlTree(['/acces-refuse']);
};
